import React, { useEffect, memo, useContext, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

import "./styles.scss";

// Common components (essential for first render)
import { BackgroundBox, PageTitle, Para, ParaBold, LineLoader } from '../Common';
import Img from 'Components/Img';
import Button from 'Components/Common/Button';
import { SkeletonLoader } from "Components/Skeletion";

// Context & Utilities
import DomainContext from "Context/DomainContext";
import { APIQueryPost } from "APIMethods/API";
import { SessionExpiredLogout, getCartItems, useWindowSize, handleImage } from "Utilities";

// Redux actions
import {
    ACTION_CUSTOMER__QUOTE__ID,
    ACTION_GUESTQUOTE__DETAILS,
    ACTION_GUESTKEY,
    ACTION_RECENT_VIEW_LOAD,
    ACTION__MAKE_TO_QUOTE_ID,
    ACTION_OPENCART,
    ACTION__MINICART__ITEMS
} from "Store/action";

import { Toggleup, Toggledown, InvoiceIcon } from 'Res/icons';
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import Seo from "Components/Seo/Seo";
import Tooltip from "@mui/material/Tooltip";

const OrdersView = ({ orderTitle = "", data, loading = true, customerData, addressData }) => {
    const { storeId, defaultURL,baseURL } = useContext(DomainContext);
    const navigate = useNavigate();
    const [width] = useWindowSize()
    const dispatch = useDispatch();
    const [isProcessing, setIsProcessing] = useState(false);
    const [resPonse, setResponse] = useState("");
    const token = useSelector((state) => state?.token);
    const customerQuoteId = useSelector((state) => state?.customerQuoteId);
    const customerId = useSelector((state) => state?.customerDetails?.id);
    const isSessionExpired = useSelector((state) => state?.isSessionExpired);
    const commonLoader = <SkeletonLoader length={4} width="170px" height="22px" full={true} />;
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const createdAt = data?.createdAt;
    const isLoggedUser = useSelector((state) => state?.isLoggedUser);
    const { t } = useTranslation();

    useEffect(() => {
        const calculateDateBefore = (createdAt, daysBefore) => {
            if (!createdAt) {
                return null;
            }
            const [day, month, year] = createdAt.split('-').map(Number);
            if (!day || !month || !year) {
                return null;
            }
            const createdDate = new Date(year, month - 1, day);
            createdDate.setDate(createdDate.getDate() - daysBefore);
            return createdDate;
        };

        const daysBefore = 15;
        const dateBefore = calculateDateBefore(createdAt, daysBefore);
        if (!dateBefore) {
            return;
        }
        const currentDate = new Date();

        if (currentDate >= dateBefore) {
            setIsButtonDisabled(true);
        }

    }, [data?.createdAt]);
   
    const reOrder = () => {
        const loginOptions = {
            isLoader: true,
            loaderAction: bool => {
                if (bool) {
                    setIsProcessing(bool);
                }
            },
            setGetResponseData: (resData) => {
                if (resData?.data?.[0]?.code === 200) {
                    if (width >= 768) {
                        dispatch(ACTION__MINICART__ITEMS("cart"))
                      }
                      else {
                        navigate("/winkelwagen")
                      }
                  
                 getCartItems(dispatch, setIsProcessing, customerQuoteId, customerId, () => dispatch(ACTION_OPENCART(true)), defaultURL, storeId, token, navigate, isSessionExpired, width);
                } else {
                    setResponse(resData?.data?.[0]?.message);
                    setIsProcessing(false);
                }
            },
            axiosData: {
                url: `${defaultURL}/customer/reorder`,
                headers: { Authorization: `Bearer ${token}` },
                paramsData: {
                    data: {
                        cart_id: customerQuoteId,
                        order_id: data?.orderId
                    }
                }
            },
            getStatus: (res) => {
                SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired);
            }
        }
        APIQueryPost(loginOptions);
    }
    const getCustomerQuoteId = () => {
        const quoteIdOptions = {
          isLoader: true,
          setGetResponseData: (resData) => {
            if (resData?.status === 200) {
              dispatch(ACTION_CUSTOMER__QUOTE__ID(resData?.data));
                 navigate("/checkout");
            }
          },
          getStatus: (res) => {
            SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired);
          },
          axiosData: {
            url: `${defaultURL}/carts/mine`,
            method: "post",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        };
        APIQueryPost(quoteIdOptions);
      };
      const getQuoteStatus = (id) => {
        const options = {
          isLoader: true,
          loaderAction: (bool) => dispatch(ACTION_RECENT_VIEW_LOAD(bool)),
          setGetResponseData: (resData) => {
            if (resData?.data[0]?.code === 400) {
              if (isLoggedUser) {
                dispatch(ACTION_CUSTOMER__QUOTE__ID(""));
                getCustomerQuoteId();
              }
              else {
                dispatch(ACTION_GUESTKEY(""));
                dispatch(ACTION_GUESTQUOTE__DETAILS({}));
              }
            }
          },
          axiosData: {
            url: `${baseURL}/cart/verify`,
            paramsData: {
              data: {
                cartId: id,
                storeId: storeId,
              }
            }
          }
        };
        APIQueryPost(options);
      };
    const makeQuoteToOrder = () => {

        const loginOptions = {
            isLoader: true,
            loaderAction: bool => {
                if (bool) {
                    setIsProcessing(bool);
                }
            },
            setGetResponseData: (resData) => {
                if (resData?.status === 200 && resData?.data?.[0]?.success) {
                    getQuoteStatus(customerQuoteId)
                    setIsProcessing(true);

                    // if (width >= 768) {
                    //     dispatch(ACTION__MINICART__ITEMS("cart"))
                    //   }
                    //   else {
                    //     navigate("/winkelwagen")
                    //   }
                  
                //  getCartItems(dispatch, setIsProcessing, customerQuoteId, customerId, () => dispatch(ACTION_OPENCART(true)), defaultURL, storeId, token, navigate, isSessionExpired, width);
                } else {
                    setResponse(resData?.data?.[0]?.message);
                    setIsProcessing(false);
                }
            },
            axiosData: {
                url: `${defaultURL}/quote/makeQuoteToOrder`,
                headers: { Authorization: `Bearer ${token}` },
                paramsData: {
                        currentQuoteId: customerQuoteId,
                        exsistingQuoteId: parseInt(data?.quoteId)
                }
            },
            getStatus: (res) => {
                SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired);
            }
        }
        //make to quote id is store for - (In checkout the api is triggered for back to quote if the customer redirect or back to previous page)
        dispatch(ACTION__MAKE_TO_QUOTE_ID(customerQuoteId));
        APIQueryPost(loginOptions);
    }




    return (
        <>
            {/* {
                orderTitle === "Ordernummer" ?
                    <Seo
                         //commented for purpose
                        // metaTitle={storeId === 1 ? "Bestelweergave | Promofit.nl" : "Bestelweergave Expofit.nl"}
                        metaTitle={`${orderTitle} #${data?.incrementId ? data?.incrementId : ""} | ${storeId === 1 ? "Promofit.nl" : "Expofit.nl"}`}
                        metaDescription="Bestelweergave"
                        metaKeywords="Bestelweergave"
                    />
                    : <></>
            }
            {
                orderTitle === "Offertenummer" ?
                    <Seo
                        //commented for purpose
                        // metaTitle={storeId === 1 ? "Citaatweergave | Promofit.nl" : "Citaatweergave Expofit.nl"}
                        metaTitle={`${storeId === 1 ? `Offertenummer #${data?.quoteId ? data?.quoteId :""} | Promofit.nl` : "Citaatweergave Expofit.nl"}`}
                        metaDescription="Citaatweergave"
                        metaKeywords="Citaatweergave"
                    />
                    : <></>
            } */}

{(!loading && orderTitle === "Ordernummer") ? (
  <Seo
    metaTitle={`${orderTitle} #${data?.incrementId} | ${
      storeId === 1 ? "Promofit.nl" : "Expofit.nl"
    }`}
    metaDescription="Bestelweergave"
    metaKeywords="Bestelweergave"
  />
) : (
  <Seo
    metaTitle={`${
      storeId === 1 ? "Ordernummer | Promofit.nl" : "Ordernummer | Expofit.nl"
    }`}
    metaDescription="Bestelweergave"
    metaKeywords="Bestelweergave"
  />
)}

{(!loading && orderTitle === "Offertenummer" && data) ? (
  <Seo
    metaTitle={`${
      storeId === 1
        ? `Offertenummer #${data?.quoteId} | Promofit.nl`
        : "Citaatweergave Expofit.nl"
    }`}
    metaDescription="Citaatweergave"
    metaKeywords="Citaatweergave"
  />
) : (
  <Seo
    metaTitle={`${
      storeId === 1
        ? `Offertenummer | Promofit.nl`
        : "Citaatweergave Expofit.nl"
    }`}
    metaDescription="Citaatweergave"
    metaKeywords="Citaatweergave"
  />
)}



            <div className='orders__view__page'>
                <div className='flex gap-6 col'>
                    {
                        loading ?
                            <BackgroundBox className='pt-6 pb-7 px-5 lg-pt-5 lg-px-8 lg-pb-8'>
                                <div className="flex col gap-y-5 space-between xxl-flex order__action center xxl-middle xxl-row pb-7 xxl-pb-4">
                                    <PageTitle className='fs-22 lg-fs-30 line-12 fw-700'>
                                        <LineLoader width="180px" height="48px" />
                                    </PageTitle>
                                    <Button className='fs-13 fw-700 r-5'>
                                        <LineLoader width="170px" height="40px" />
                                    </Button>
                                </div>
                                <div className="topdetails pb-7 lg-pb-9">{commonLoader}</div>

                                {orderTitle === "Ordernummer" ?
                                    <div className="address flex col gap-y-8 gap-x-4 sm-flex sm-row pb-7 xxl-pb-9">
                                        {
                                            ['', ''].map((item, ind) => (
                                                <div className="flex col gap-1" key={`orderDetailsAddressLoader${ind + 1}`}>
                                                    <LineLoader width="170px" height="28px" />
                                                    {commonLoader}
                                                </div>
                                            ))
                                        }
                                    </div>
                                    : <></>}
                                <div className='fs-15 line-6 fw-700 pb-5 lg-pb-4 pt-2'>
                                    <LineLoader width="170px" height="22px" />
                                </div>
                                <div className="productdetails">
                                    <SkeletonLoader length={3} width="100%" height="350px" full={true} />
                                </div>
                                <div className="summary__block py-7 lg-py-10 flex right">
                                    <SkeletonLoader length={7} width="170px" height="27px" full={true} />
                                </div>
                                <SkeletonLoader pclassName="flex col gap-y-5 sm-flex sm-row sm-space-between order__action sm-center sm-middle" length={2} width="170px" height="27px" full={true} />
                            </BackgroundBox> :
                            <BackgroundBox className='pt-6 pb-7 px-5 lg-pt-5 lg-px-8 lg-pb-8'>
                                <div className="flex col gap-y-5 space-between xxl-flex order__action center xxl-middle xxl-row pb-7 xxl-pb-4">
                                    <PageTitle className='fs-22 lg-fs-30 line-12 fw-700 no-translate notranslate '><Button onClick={() => navigate(`/mijn-account/${orderTitle === "Ordernummer" ? 'mijn-bestellingen' : 'mijn-offertes'}`)} className="fs-22 lg-fs-30">{`<`}</Button>
                                     <span>{ orderTitle === "Ordernummer" ? <span className="no-translate notranslate">{t("Ordernummer")}</span> : <span className="no-translate notranslate">{t("Offertenummer")}</span>}</span> #{orderTitle === "Ordernummer" ? data?.incrementId : data?.quoteId}
                                     </PageTitle>
                                    {

                                        orderTitle === "Ordernummer" && data?.displayReorder == 1 && data?.isSample !== '1' ?
                                              <Tooltip
                                                   placement="top-start"
                                                   title={data?.quote_expired_message?.trim()}
                                                   classes={{ tooltip: "custom-tooltip" }}
                                                   enterTouchDelay={0}
                                                   leaveTouchDelay={9999999}
                                                  >
                                            <Button
                                                className={`fs-13 fw-700 r-5 ${isProcessing ? 'rotateUpdate' : ''}`}
                                                onClick={() => reOrder()}
                                            >{isProcessing ? <AutorenewIcon /> : <>
                                               <span className="no-translate notranslate">{t("Opnieuw_bestellen")}</span><Toggleup role="presentation" />
                                            </>}</Button>                                                    
                                        </Tooltip>
                                            : <></>
                                    }
                                    {
                                        orderTitle === "Offertenummer" && (data?.status == 1 || data?.status == 3)  ?
                                             <Tooltip
                                                   placement="top-start"
                                                   title={data?.quote_expired_message?.trim()}
                                                   classes={{ tooltip: "custom-tooltip" }}
                                                   enterTouchDelay={0}
                                                   leaveTouchDelay={9999999}
                                                  >
                                                    <span>
                                            <Button
                                                className={`fs-13 fw-700 r-5 ${isProcessing ? 'rotateUpdate' : ''}`}
                                                onClick={() => makeQuoteToOrder()}
                                                disabled={data?.status == 3}
                                            >{isProcessing ? <AutorenewIcon /> : <>
                                                <span className="no-translate notranslate">{t("Opnieuw_bestellen")}</span> <Toggleup role="presentation" />
                                            </>}</Button>
                                                    </span>
                                            </Tooltip>
                                            : <></>
                                    }
                                </div>
                                {resPonse && <div className="fs-15 res__message pb-3 error">{resPonse}</div>}
                                <div className="topdetails pb-7 lg-pb-9">
                                    <ParaBold>{data?.createdAt}&nbsp;&nbsp;&nbsp;{data?.createdTime}</ParaBold>
                                    <Para className='fs-15 line-6 pt-1 title'>
                                        {orderTitle === "Ordernummer" && data?.order_detail_exists ?
                                            data?.isSample === '1' ?
                                                <span className="label no-translate notranslate">{t("Sample_bestelling")}</span>
                                                :
                                                <><span className="label no-translate notranslate">{t("Online_bestelling")}</span><span style={{ color: data?.status === 'In afwachting' || data?.status === 'In behandeling' ? '#EF8700' : '#52B80E' }}>{data?.status}</span></>
                                            :
                                            <>
                                            </>
                                        }
                                    </Para>

                                    <Para className='fs-15 line-6 pt-1 title'>
                                        {orderTitle === "Offertenummer" ?
                                            customerData ?
                                                <>
                                                    <span className="label no-translate notranslate">{t("Offerteaanvraag")}:</span>
                                                    <span className="label">{data?.quote_mode}</span>
                                                </>
                                                :
                                                <></>
                                            :
                                            <></>
                                        }
                                    </Para>
                                    <Para className='fs-15 line-6 pt-1 title'>
                                        {orderTitle === "Offertenummer" ?
                                            data?.expiry_status || data?.quote_status_title ?
                                                <>
                                                    <span className="label">Status:</span>
                                                    <span className="" style={{display:"inline"}}>{data?.expiry_status?data?.expiry_status:data?.quote_status_title}</span>
                                                </>
                                                :
                                                <></>
                                            :
                                            <></>
                                        }
                                    </Para>
                                    <Para className='fs-15 line-6 pt-1 title'>
                                        {orderTitle === "Offertenummer" ?
                                            data?.expiry_date ?
                                                <>
                                                    <span className="label">Expiry Date:</span>
                                                    <span className="label">{data?.expiry_date}</span>
                                                </>
                                                :
                                                <></>
                                            :
                                            <></>
                                        }
                                    </Para>
                                    {orderTitle === "Ordernummer" && data?.paymentMethod !== null && data?.order_detail_exists?
                                        <Para className='fs-15 line-6 pt-1 title'><span className="label no-translate notranslate">{t("Betaalmethode")}:</span><span className=''>{data?.paymentMethod}</span></Para>
                                        : <></>}
                                    {orderTitle === "Ordernummer" && data?.InvoiceData?.length && data?.order_detail_exists ? (
                                        <Para className='fs-15 line-6 flex title'>
                                            <span className="label no-translate notranslate">{t("Factuur")}:</span>
                                            <div className="flex col">
                                                {data.InvoiceData.map((invoice, index) => (
                                                    <span
                                                        key={index}
                                                        className="pointer"
                                                        onClick={() => window.open(invoice.link, "_blank", "noreferrer")}
                                                    >
                                                        <span className='pr-2 text-underline no-translate notranslate'>{t("bekijken")}</span>
                                                        <span className="payment relative line-1"><InvoiceIcon /></span>
                                                    </span>
                                                ))}
                                            </div>

                                        </Para>
                                    ) : null}

                                </div>

                                {orderTitle === "Offertenummer" ?
                                    <div className="topdetails pb-7 lg-pb-9">
                                        <ParaBold><span className=" no-translate notranslate">{t("Uw gegevens")}</span></ParaBold>
                                        <Para className='fs-15 line-6 pt-1 title no-translate notranslate'>
                                            {data?.quote_companyname}
                                        </Para>
                                        <Para className='fs-15 line-6 pt-1 title no-translate notranslate'>
                                            {data?.quote_customername}
                                        </Para>

                                        <Para className='fs-15 line-6 pt-1 title'>
                                            {data?.quote_telephone}
                                        </Para>
                                    </div>

                                    :
                                    <></>
                                }

                                 {(orderTitle === "Offertenummer" && addressData) ?
                                    <div className="address flex col gap-y-8 gap-x-4 sm-flex sm-row pb-7 xxl-pb-9">
                                        <div className="flex col">
                                            <ParaBold className='fs-15 line-6 fw-700 pb-1 no-translate notranslate'>{t("Factuuradres")}</ParaBold>
                                            <Para><span className=" no-translate notranslate">{addressData?.billing_address?.company} </span></Para>
                                            <Para><span className=" no-translate notranslate">{addressData?.billing_address?.firstname} {addressData?.billing_address?.lastname}</span></Para>
                                            <Para> <span className=" no-translate notranslate">{addressData?.billing_address?.street1} {addressData?.billing_address?.street2} {addressData?.billing_address?.doorNo} {addressData?.billing_address?.additional_details}</span></Para>
                                            <Para>{addressData?.billing_address?.postcode} {addressData?.billing_address?.city}</Para>
                                            <Para>{addressData?.billing_address?.country_code}</Para>
                                            <Para>Tel. {addressData?.billing_address?.mobile_number}</Para>
                                            <Para>{addressData?.billing_address?.vat_id}</Para>
                                        </div>
                                        <div className="flex col">
                                            <ParaBold className='fs-15 line-6 fw-700 pb-1'>{"Afleveradres"}</ParaBold>
                                            <Para><span className="no-translate notranslate">{addressData?.shipping_address?.company}</span></Para>
                                            <Para><span className="no-translate notranslate">{addressData?.shipping_address?.firstname} {addressData?.shipping_address?.lastname}</span></Para>
                                            <Para><span className="no-translate notranslate">{addressData?.shipping_address?.street1} {addressData?.shipping_address?.street2} {addressData?.shipping_address?.doorNo} {addressData?.shipping_address?.additional_details}</span></Para>
                                            <Para>{addressData?.shipping_address?.postcode} {addressData?.shipping_address?.city}</Para>
                                            <Para>{addressData?.shipping_address?.country_code}</Para>
                                            <Para>Tel. {addressData?.shipping_address?.mobile_number}</Para>
                                            <Para>{addressData?.shipping_address?.vat_id}</Para>
                                        </div>
                                    </div>
                                    : <></>}

                                {orderTitle === "Ordernummer" && data?.order_detail_exists ?
                                    <div className="address flex col gap-y-8 gap-x-4 sm-flex sm-row pb-7 xxl-pb-9">
                                        <div className="flex col">
                                            <ParaBold className='fs-15 line-6 fw-700 pb-1 no-translate notranslate'>{t("Factuuradres")}</ParaBold>
                                            <Para><span className=" no-translate notranslate">{data?.billingAddress?.company} </span></Para>
                                            <Para><span className=" no-translate notranslate">{data?.billingAddress?.firstname} {data?.billingAddress?.lasttname}</span></Para>
                                            <Para> <span className=" no-translate notranslate">{data?.billingAddress?.street} {data?.billingAddress?.doorNo} {data?.billingAddress?.additional_details}</span></Para>
                                            <Para>{data?.billingAddress?.postcode} {data?.billingAddress?.city}</Para>
                                            <Para>{data?.billingAddress?.countryName}</Para>
                                            <Para>Tel. {data?.billingAddress?.telephone}</Para>
                                            <Para>{data?.billingAddress?.vat_id}</Para>
                                        </div>
                                        <div className="flex col">
                                            <ParaBold className='fs-15 line-6 fw-700 pb-1'>{data?.instorePickup?"Afhaaladres":"Afleveradres"}</ParaBold>
                                            <Para><span className="no-translate notranslate">{data?.shippingAddress?.company}</span></Para>

                                            <Para><span className="no-translate notranslate">{data?.shippingAddress?.firstname} {data?.shippingAddress?.lasttname}</span></Para>
                                            <Para><span className="no-translate notranslate">{data?.shippingAddress?.street} {data?.shippingAddress?.doorNo} {data?.shippingAddress?.additional_details}</span></Para>
                                            <Para>{data?.shippingAddress?.postcode} {data?.shippingAddress?.city}</Para>
                                            <Para>{data?.shippingAddress?.countryName}</Para>
                                            <Para>Tel. {data?.shippingAddress?.telephone}</Para>
                                            <Para>{data?.shippingAddress?.vat_id}</Para>
                                        </div>
                                    </div>
                                    : <></>}
                                    {data?.order_detail_exists ?
                                <Para className='fs-15 line-6 fw-700 pb-5 lg-pb-4 pt-2'>Totaal {data?.items?.length} artikel(en)</Para>
:<></>
                                    }
                                <div className="productdetails">
                                    {
                                        data?.items?.length ?
                                            data?.items?.map((item, key, arg) => (
                                                <div className="items" key={`${orderTitle}${key}`}>
                                                    <div className='flex col w-1/1'>
                                                        <div className="py-7 lg-py-10">
                                                            <div className='flex col xl-flex xl-row gap-8 start w-1/1'>
                                                                <div className=" flex-0 flex">
                                                                    <div className="product__img flex relative center">
                                                                        <Link to={`/${item?.urlKey}`}aria-label={item?.productName} className='relative' style={{width:"100%"}}>
                                                                            <Img src={handleImage(item?.productImage)} />
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className="flex col flex-1">
                                                                    <div className="flex">
                                                                        <div className="flex-1 flex col social__detail top">
                                                                            <Link to={`/${item?.urlKey}`} aria-label={item?.productName}>
                                                                                <h3 className="fw-700 line-7">{item?.productName}</h3>
                                                                            </Link>
                                                                            <div className="details__block flex col left w-1/1">
                                                                                <div className="flex w-1/1">
                                                                                    <div className="flex-1 pt-3 w-1/1">
                                                                                        <ListItems orderTitle={orderTitle} item={item} arg={arg} articleNumber={item?.productSku} number={item?.productQty} sku={item?.price} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-0 no-translate notranslate">
                                                                            <h3 className="fw-700 fs-20 tr text-nowrap">{orderTitle === "Ordernummer" && data?.order_detail_exists ? item?.subTotal : item?.sub_total}</h3>
                                                                        </div>
                                                                    </div>
                                                                    <div className='deliveryTime r-5 mt-5 w-1/1 flex-1'>
                                                                        <div className="content py-5 pr-5 xxl-pr-20 pl-4">
                                                                            <div className="flex w-1/1 gap-3">
                                                                                <div className="flex-0">
                                                                                    <div className="icon">
                                                                                        <AccessTimeIcon />
                                                                                    </div>
                                                                                </div>

                                                                                {item?.odoo_delivery_details?.odoo_actual_delivery_date || item?.odoo_delivery_details?.odoo_expected_delivery_date ?
                                                                                    <React.Fragment>
                                                                                        {
                                                                                            item?.odoo_delivery_details?.odoo_actual_delivery_date ?
                                                                                                <div className="flex-1 flex col gap-1">
                                                                                                    {/* <h3 className="fs-16 fw-700 line-6"><span className="no-translate notranslate">{t("Verzonden_op")}</span> {item?.odoo_delivery_details?.odoo_actual_delivery_date}</h3> */}

                                                                                                    {item?.odoo_delivery_details?.odoo_tracking_number ?
                                                                                                        <div className="odoo_deliverydays">
                                                                                                            <a href={item?.odoo_delivery_details?.odoo_tracking_url} className="fs-15 line-6">{item?.odoo_delivery_details?.odoo_tracking_number}</a>
                                                                                                        </div>
                                                                                                        : ""}
                                                                                                </div>
                                                                                                : item?.odoo_delivery_details?.odoo_expected_delivery_date ?
                                                                                                    <div className="flex-1 flex col gap-1">
                                                                                                        <h3 className="fs-16 fw-700 line-6"><span className="no-translate notranslate">{t("Verwachte_verzenddatum")}</span> {item?.odoo_delivery_details?.odoo_expected_delivery_date}</h3>
                                                                                                        {item?.odoo_delivery_details?.odoo_expected_delivery_date ?
                                                                                                            <p className="fs-15 line-6">{item?.odoo_delivery_details?.odoo_delivery_comments}</p> : null

                                                                                                        }


                                                                                                    </div>
                                                                                                    : null}
                                                                                    </React.Fragment>

                                                                                    :

                                                                                    <div className="flex-1 flex col gap-1">
                                                                                        <h3 className="fs-16 fw-700 line-6"><span className="no-translate notranslate">{t("Verwachte_verzenddatum")}</span> {item?.deliveryDays?.send_to_day} {item?.deliveryDays?.send_to_month} {item?.deliveryDays?.send_to_year}</h3>
                                                                                        <p className="fs-15 line-6" dangerouslySetInnerHTML={{ __html: `Bezorgopmerkingen: ${item?.deliveryDays?.text}` }}></p>
                                                                                    </div>
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            : !data?.order_detail_exists ?
                                           <div className="items" >
                                                    <div className='flex col w-1/1'>
                                                        <div className="py-7 lg-py-10">
                                                            <div className='flex col xl-flex xl-row gap-8 start w-1/1'>
                                                                <div className=" flex-0 flex">
                                                                    <div className="product__img flex relative center">
                                                                        <Link to="" aria-label={data?.product_name} className='relative' style={{width:"100%"}}>
                                                                            <Img src="" />
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className="flex col flex-1">
                                                                    <div className="flex">
                                                                        <div className="flex-1 flex col social__detail top">
                                                                            <Link to={`/${data?.product_url_key}`} aria-label={data?.product_name}>
                                                                                <h3 className="fw-700 line-7">{data?.product_name}</h3>
                                                                            </Link>
                                                                           
                                                                        </div>
                                                                       
                                                                    </div>
                                                                   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            : <></>
                                    }
                                </div>
                               
                                <div className="summary__block py-7 lg-py-10 flex right">
                                {  orderTitle === "Ordernummer" && data?.order_detail_exists ?
                                <table className="w-1/1">
                                    <tbody>
                                        {data?.isSample == 1 ? null :
                                        <>
                                         <tr>
                                            <td className="no-translate notranslate">{t("Digitale drukproef")}</td>
                                            <td>
                                                <b className="normal green">{data?.digitalProof === null ? 'Gratis' : data?.digitalProof}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="no-translate notranslate">{t("Instelkosten")}</td>
                                            {
                                                data?.setupCost === "" || data?.setupCost === "0,00" || data?.setupCost === "0" || data?.setupCost === 0 ? <td><b className="normal green no-translate notranslate">{t("Gratis")}</b></td> : <td className=" no-translate notranslate">{data?.setupCost}</td>
                                            }
                                        </tr>
                                        </>
                                        }
                                       
                                        <tr>
                                            <td>{data?.shippingTitle}</td>
                                            {
                                                data?.postageCosts === "" || data?.postageCosts === "0,00" || data?.postageCosts === "0" || data?.postageCosts === 0 ? <td><b className="normal green no-translate notranslate">{t("Gratis")}</b></td> : <td className={`${data?.postageCosts !== "op nacalculatie *" ? "no-translate notranslate" : ""}`}>{data?.postageCosts}</td>
                                            }
                                        </tr>

                                        {data?.productCostValue && Object.values(data?.productCostValue)?.map(item => (
                                            <tr>
                                                <td>{item?.label}</td>
                                                <td className=" no-translate notranslate">{item?.productCost}</td>
                                            </tr>
                                        ))}
                                        {
                                            data?.couponCode ?
                                                <tr>
                                                    <td><span className="no-translate notranslate">{t("Kortingscode")}</span> ({data?.couponCode})</td>
                                                    <td className=" no-translate notranslate">-{data?.coupon_amount}</td>
                                                </tr>
                                                : <></>
                                        }
                                         {data?.custom_price?.length > 0 && (
                                            Object.entries(
                                                data.custom_price.reduce((acc, item) => {
                                                const label = item.label;
                                                const value = parseFloat(item.value);
                                                acc[label] = (acc[label] || 0) + value;
                                                return acc;
                                                }, {})
                                            ).map(([label, total], index) => (
                                                <tr key={`custom-price-${index}`}>
                                                <td>{label}</td>
                                                <td>{total.toFixed(2).replace('.', ',')}</td>
                                                </tr>
                                            ))
                                            )}
                                        <tr className="fw-700 total">
                                            <td className="no-translate notranslate">{t("Totaal (excl. BTW)")}</td>
                                            <td className="no-translate notranslate">{data?.subTotals}</td>
                                        </tr>
                                        {/* <tr>
                                            <td className="no-translate notranslate">{t("BTW")}</td>
                                            <td className="no-translate notranslate">{data?.TaxAmount}</td>
                                        </tr> */}
                                       {
                                        data?.tax_breakdown &&
                                        (
                                            data.tax_breakdown.every(tax => tax.tax_amount === "0,00") ? (
                                            <tr>
                                               <td className="no-translate notranslate">{"BTW 0%"}</td>
                                                <td className="no-translate notranslate">0,00</td>
                                            </tr>
                                            ) : (
                                            data.tax_breakdown.map((tax, index) => (
                                                <tr key={index}>
                                                <td className="no-translate notranslate">
                                                {t("BTW")}{tax?.tax_amount !== "0,00" ? ` ${tax?.tax_rate}% ${tax?.country_code}` : ""}
                                                </td>
                                                <td className="no-translate notranslate">{tax?.tax_amount}</td>
                                                </tr>
                                            ))
                                            )
                                        )
                                        }
                                        <tr>
                                            <td className="no-translate notranslate">{t("Totaalbedrag")}</td>
                                            <td className="no-translate notranslate">{data?.totalWithVat}</td>
                                        </tr>
                                    </tbody>
                                </table>:
                              orderTitle === "Offertenummer"   ?
                                 <table className="w-1/1">
                                 <tbody>
                                     <tr>
                                         <td className="no-translate notranslate">{t("Digitale drukproef")}</td>
                                         <td>
                                             <b className="normal green">{data?.digitalProof === null ? 'Gratis' : data?.digitalProof}</b>
                                         </td>
                                     </tr>
                                     <tr>
                                         <td className="no-translate notranslate">{t("Instelkosten")}</td>
                                         {
                                             data?.setupCost === "" || data?.setupCost === "0,00" || data?.setupCost === "0" || data?.setupCost === 0 ? <td><b className="normal green no-translate notranslate">{t("Gratis")}</b></td> : <td className="no-translate notranslate">{data?.setupCost}</td>
                                         }
                                     </tr>
                                     <tr>
                                         <td className="no-translate notranslate">{t("Verzendkosten")}</td>
                                         {
                                             data?.postageCosts === "" || data?.postageCosts === "0,00" || data?.postageCosts === "0" || data?.postageCosts === 0 ? <td><b className="normal green no-translate notranslate">{t("Gratis")}</b></td> : <td>{data?.postageCosts}</td>
                                         }
                                     </tr>

                                     {data?.productCostValue && Object.values(data?.productCostValue)?.map(item => (
                                         <tr>
                                             <td>{item?.label}</td>
                                             <td className=" no-translate notranslate">{item?.productCost}</td>
                                         </tr>
                                     ))}
                                     {
                                         data?.couponCode ?
                                             <tr>
                                                 <td><span className="no-translate notranslate">{t("Kortingscode")}</span> ({data?.couponCode})</td>
                                                 <td className=" no-translate notranslate">-{data?.coupon_amount}</td>
                                             </tr>
                                             : <></>
                                     }

                                     {data?.custom_price?.length > 0 && (
                                            Object.entries(
                                                data.custom_price.reduce((acc, item) => {
                                                const label = item.label;
                                                const value = parseFloat(item.value);
                                                acc[label] = (acc[label] || 0) + value;
                                                return acc;
                                                }, {})
                                            ).map(([label, total], index) => (
                                                <tr key={`custom-price-${index}`}>
                                                <td>{label}</td>
                                                <td>{total.toFixed(2).replace('.', ',')}</td>
                                                </tr>
                                            ))
                                            )}
                                            
                                     <tr className="fw-700 total">
                                         <td className="no-translate notranslate">{t("Totaal (excl. BTW)")}</td>
                                         <td className=" no-translate notranslate">{data?.subTotals}</td>
                                     </tr>
                                       {
                                        data?.tax_breakdown && (
                                            data.tax_breakdown.every(tax => tax.tax_amount === "0,00") ? (
                                            <tr>
                                                <td className="no-translate notranslate">{"BTW 0%"}</td>
                                                <td className="no-translate notranslate">0,00</td>
                                            </tr>
                                            ) : (
                                            data.tax_breakdown.map((tax, index) => (
                                                <tr key={index}>
                                                <td className="no-translate notranslate">
                                                {t("BTW")}{tax?.tax_amount !== "0,00" ? ` ${tax?.tax_rate}% ${tax?.country_code}` : ""}
                                                </td>                                                
                                                <td className="no-translate notranslate">{tax?.tax_amount}</td>
                                                </tr>
                                            ))
                                            )
                                        )
                                        }
                                     {/* <tr>
                                         <td className="no-translate notranslate">{t("BTW")}</td>
                                         <td className=" no-translate notranslate">{data?.TaxAmount}</td>
                                     </tr> */}
                                     <tr>
                                         <td className="no-translate notranslate">{t("Totaalbedrag")}</td>
                                         <td className=" no-translate notranslate">{data?.totalWithVat}</td>
                                     </tr>
                                 </tbody>
                             </table>
                             :
                                 <></>
                                     }
                            </div>
                           
                                
                                <div className="flex col gap-y-5 sm-flex sm-row sm-space-between order__action sm-center sm-middle">
                                    <Button
                                        className='fs-14 back'
                                        onClick={() => navigate(-1)}
                                    ><span className="arrow">{`<`}</span>&nbsp;<span className="no-translate notranslate">{t("terug naar")} {orderTitle === "Ordernummer" ? t("bestellingen") : t("offerteaanvragen")}</span></Button>
                                    {
                                        orderTitle === "Ordernummer" && data?.displayReorder == 1 && data?.isSample !== '1' ?
                                         <Tooltip
                                                   placement="top-start"
                                                   title={data?.quote_expired_message?.trim()}
                                                   classes={{ tooltip: "custom-tooltip" }}
                                                   enterTouchDelay={0}
                                                   leaveTouchDelay={9999999}
                                                  >
                                        <Button
                                                className={`fs-13 fw-700 r-5 ${isProcessing ? 'rotateUpdate' : ''}`}
                                                onClick={() => reOrder()}
                                            >{isProcessing ? <AutorenewIcon /> : <>
                                                <span className="no-translate notranslate">{t("Opnieuw_bestellen")}</span> <Toggleup role="presentation" />
                                            </>}</Button></Tooltip>   
                                            : <></>
                                    }
                                    {
                                        orderTitle === "Offertenummer" && (data?.status == 1 || data?.status == 3)  ?
                                        <Tooltip
                                                   placement="top-start"
                                                   title={data?.quote_expired_message?.trim()}
                                                   classes={{ tooltip: "custom-tooltip" }}
                                                   enterTouchDelay={0}
                                                   leaveTouchDelay={9999999}
                                                  > 
                                                  <span>
                                              <Button
                                                className={`fs-13 fw-700 r-5 ${isProcessing ? 'rotateUpdate' : ''}`}
                                                onClick={() => makeQuoteToOrder()}
                                                disabled={data?.status == 3}
                                            >{isProcessing ? <AutorenewIcon /> : <>
                                                <span className="no-translate notranslate">{t("Opnieuw_bestellen")}</span> <Toggleup role="presentation" />
                                            </>}</Button>
                                                  </span>
                                       </Tooltip>  
                                            : <></>
                                    }
                                </div>
                            </BackgroundBox>
                    }
                </div>
            </div>
        </>
    )
}

export default memo(OrdersView);

const ListItems = ({ orderTitle, item, arg, articleNumber, number, sku }) => {
    const [showDetails, setShowDetails] = useState(false);
    const handleItemClick = () => {
        setShowDetails(!showDetails);
    }
    const { t } = useTranslation();


    return (
        <>
            <div className="cart__details__options w-1/1">
                <table className='w-1/1'>
                    <tbody>
                        {
                            articleNumber ?
                                <tr>
                                    <td>
                                        <div className="fs-15 no-translate notranslate">{t("Artikelnummer")}</div>
                                    </td>
                                    <td>
                                        <div className="fs-15">{articleNumber}</div>
                                    </td>
                                </tr>
                                : <></>
                        }
                        {
                            number ?
                                <tr>
                                    <td>
                                        <div className="fs-15 no-translate notranslate">{t("Aantal")}</div>
                                    </td>
                                    <td>
                                        <div className="fs-15">{number}</div>
                                    </td>
                                </tr>
                                : <></>
                        }
                        {
                            sku ?
                                <tr>
                                    <td>
                                        <div className="fs-15 no-translate notranslate">{t("Prijs per stuk")}</div>
                                    </td>
                                    <td>
                                        <div className="fs-15 no-translate notranslate">{sku}</div>
                                    </td>
                                </tr>
                                : <></>
                        }
                        {
                            showDetails && item?.options?.length ?
                                item?.options?.slice(0, item?.options?.length)?.map((option, ind) => (
                                    <tr key={`${orderTitle}itemOptions${ind}`}>
                                        <td>
                                            <div className="fs-15">{option?.label}</div>
                                        </td>
                                        <td>
                                            {
                                                option?.label === "Bestand(en)" ?
                                                    <div className="fs-15 order_view_desc" dangerouslySetInnerHTML={{ __html: option?.value }}></div>
                                                    :
                                                    <div className={`fs-15 order_view_desc ${ option?.label == "Instelkosten" ? "no-translate notranslate" : ""}`} style={{ maxWidth : "250px" , textOverflow : "ellipsis" , overflow : "hidden" , wordWrap : "break-word"}}>{option?.value}</div>
                                            }
                                        </td>
                                    </tr>
                                )) : <></>
                        }
                        {
                            showDetails && item?.dropbox?.length ? (
                                <tr>
                                    <td>
                                        <div className="fs-15 ">Bestand(en)</div>
                                    </td>
                                    <td>
                                        {
                                            item?.dropbox?.[0] === 1 || item?.dropbox?.[0] === '1' ?
                                                <div className="fs-15 no-translate notranslate">{t("LeverOntwerpLater")}</div>
                                                :
                                                <div className="fs-15 upload_file_mini_cart order_view_desc" dangerouslySetInnerHTML={{ __html: item?.dropbox?.[0].replace(/,/g, '') }}></div>
                                        }
                                    </td>
                                </tr>
                            ) : <></>
                        }

                    </tbody>
                </table>
            </div>
            {
                item?.options?.length ?
                    !showDetails ?
                        <button
                            className="mt-1 fs-14 text-underline fw-300"
                            onClick={() => handleItemClick()}
                            aria-label="button"
                        >
                          <span className="no-translate notranslate">{t("bekijk_details")}</span>  
                            <span className="flex middle">
                                <Toggledown role="presentation" />
                            </span>
                        </button>
                        :
                        <button
                            className="mt-1 fs-14 text-underline down fw-300"
                            onClick={() => handleItemClick()}
                            aria-label="button"
                        >
                          <span className="no-translate notranslate">{t("Verberg_details")}</span>  
                            <span className="flex middle">
                                <Toggleup role="presentation" />
                            </span>
                        </button>
                    : <></>
            }
        </>
    )
}